import { render, staticRenderFns } from "./living_list.vue?vue&type=template&id=2c843e0d&scoped=true&"
import script from "./living_list.vue?vue&type=script&lang=js&"
export * from "./living_list.vue?vue&type=script&lang=js&"
import style0 from "./living_list.vue?vue&type=style&index=0&id=2c843e0d&scoped=true&lang=scss&"
import style1 from "./living_list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c843e0d",
  null
  
)

export default component.exports